import { render, staticRenderFns } from "./LayoutMenu.vue?vue&type=template&id=25c95008&"
import script from "./LayoutMenu.vue?vue&type=script&lang=js&"
export * from "./LayoutMenu.vue?vue&type=script&lang=js&"
import style0 from "./LayoutMenu.vue?vue&type=style&index=0&id=25c95008&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports